import { defineOteSubscribe } from "./subscribe-element.js";

defineOteSubscribe();

export { defineOteSubscribe, OteSubscribeElement } from "./subscribe-element.js";
export type { ShowToken } from "./subscribe-attrs.js";
